import { useState } from "react";
import Header from "./header/header";
import AdminSidebar from "./componants/sidebar/AdminSidebar";

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(() => window.innerWidth <= 768);

  return (
    <div className="app-wrapper">
      <div
        className={`sidebar-overlay${!collapsed ? " active" : ""}`}
        onClick={() => setCollapsed(true)}
      />
      <AdminSidebar collapsed={collapsed} />
      <div className={`main-section ${collapsed ? "collapsed" : ""}`}>
        <Header onToggle={() => setCollapsed(!collapsed)} />
        <div className="page-content">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
